import {getLink} from "@hooks/PagesData/getLink"
import {useRouter} from "next/router"
import React, {useEffect} from "react"

const index = () => {
	const router = useRouter()

	useEffect(() => {
		void router.push(getLink("pricingOneEnterprise"))
	}, [])

	return <></>
}

export default index
